define([
  "jquery",
  "knockout"],
function($, ko) {

  "use strict";

  function renderImage(context, img, x, y) {

    context.save();

    // draw the image which will be clipped except in the clipping path
    context.drawImage(img, x, y);
  }

  function clippingPath(context, pathPoints, img, x, y) {

    context.save();

    // define the path that will be clipped to
    context.beginPath();
    context.moveTo(pathPoints[0], pathPoints[1]);
    context.lineTo(pathPoints[2], pathPoints[3]);
    context.lineTo(pathPoints[4], pathPoints[5]);
    context.closePath();

    // make the current path a clipping path
    context.clip();

    // draw the image which will be clipped except in the clipping path
    context.drawImage(img, x, y);

    // restore the unclipped context (==undo the clipping path)
    context.restore();

  }

  function loadAllImages(callback, primaryColor, secondaryColor) {

    var imagesOK = 0;
    var imgs = [];
    var imageURLs = [primaryColor, secondaryColor];

    for (var i = 0; i < imageURLs.length; i++) {
      var img = new Image();
      imgs.push(img);
      img.onload = function() {
        imagesOK++;
        if (imagesOK >= imageURLs.length) {
          callback(imgs);
        }
      };
      img.onerror = function() {
        // console.log("image load failed");
      }
      img.src = imageURLs[i];
    }
  }

  ko.bindingHandlers.colorSwatchPreview = {

    init: function(element, valueAccessor) {
      var options = ko.unwrap(valueAccessor());
      $(element).append("<canvas id='bdc-product-color-swatch-preview-double' width='50' height='50'></canvas><img alt='' id='bdc-product-color-swatch-preview-single' />");
    },

    update: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
      var options = ko.unwrap(valueAccessor());
      var colorSwatches = ko.unwrap(options.colorSwatches) || {};
      var primary = colorSwatches.primary || "";
      var secondary = colorSwatches.secondary  || "";
      var canvas = $(element).find('canvas')[0];
      var ctx = canvas.getContext("2d");
      if (primary !== "" && secondary !== "") {
        loadAllImages(function (images) {
          clippingPath(ctx, [0, 0, 0, 50, 50, 0], images[0], 0, 0);
          clippingPath(ctx, [50, 0, 50, 50, 0, 50], images[1], 0, 0);
        }, primary, secondary);
        $("#bdc-product-color-swatch-preview-single").hide();
        $("#bdc-product-color-swatch-preview-double").show();
        return;
      }
      if (primary !== "" && secondary === "") {
        $("#bdc-product-color-swatch-preview-double").hide();
        $("#bdc-product-color-swatch-preview-single").attr({src: primary, "aria-labelledby": "swatch-preview-primary"}).show();
      }
      if (primary === "" && secondary !== "") {
        $("#bdc-product-color-swatch-preview-double").hide();
        $("#bdc-product-color-swatch-preview-single").attr({src: secondary, "aria-labelledby": "swatch-preview-secondary"}).show();
      }
    }
  };

});
